// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-switch {
  width: 3.6rem;
  height: 1.8rem;
  background: var(--grey-text);
  border-radius: 1.2rem;
  position: relative;
  appearance: none;
  outline: none;
  cursor: pointer;
  transition: 0.2s;
}
.app-switch:before {
  content: "";
  width: 1.6rem;
  height: 1.6rem;
  background: var(--white);
  border-radius: 50%;
  position: absolute;
  top: 0.1rem;
  left: 0.1rem;
  transition: 0.2s;
}
.app-switch:checked {
  background: var(--primary);
}
.app-switch:checked:before {
  left: 1.9rem;
}
.app-switch:hover {
  background: var(--primary-70);
}`, "",{"version":3,"sources":["webpack://./src/shared/switch/switch.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,cAAA;EACA,4BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AACF;AACE;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AACJ;AAEE;EACE,0BAAA;AAAJ;AAEI;EACE,YAAA;AAAN;AAIE;EACE,6BAAA;AAFJ","sourcesContent":[".app-switch {\n  width: 3.6rem;\n  height: 1.8rem;\n  background: var(--grey-text);\n  border-radius: 1.2rem;\n  position: relative;\n  appearance: none;\n  outline: none;\n  cursor: pointer;\n  transition: 0.2s;\n\n  &:before {\n    content: '';\n    width: 1.6rem;\n    height: 1.6rem;\n    background: var(--white);\n    border-radius: 50%;\n    position: absolute;\n    top: 0.1rem;\n    left: 0.1rem;\n    transition: 0.2s;\n  }\n\n  &:checked {\n    background: var(--primary);\n\n    &:before {\n      left: 1.9rem;\n    }\n  }\n\n  &:hover {\n    background: var(--primary-70);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
